import { isFocusStudio } from 'utils/studioConfig';

import {
	getReleaseMessaging as getUniversalReleaseMessaging,
} from 'src_overrides/studios/universal-pictures-cms/utils/releaseMessaging';
import {
	getReleaseMessaging as getFocusReleaseMessaging,
	getDefaultLandingCtaText as getFocusDefaultCta
} from 'src_overrides/studios/focusfeatures/titles/focus-features-hub/utils/movie';

function getReleaseMessaging(movie, ...rest) {
	if (!movie) return null;
	return isFocusStudio() ? getFocusReleaseMessaging(movie, ...rest) : getUniversalReleaseMessaging(movie, ...rest);
}

export {
	getReleaseMessaging,
	getUniversalReleaseMessaging,
	getFocusReleaseMessaging,
	getFocusDefaultCta,
};